export default __webpack_public_path__ + "static/media/no-materials-on-site.c031b5a9.png";